<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        h1.m-0
          em Hola 
            span.text-capitalize {{user.name}}
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
            small {{moment().locale('es').format('MMMM')}} 
            | {{ Math.ceil(moment().date() / 7) }}
            small a 
            | Semana
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              .h2.mb-3.ad_text-primary
                | Esta Semana
              .col.ad_bg-gray.rounded-lg.py-4
                table.w-100.text-left.table-rounded-body
                  thead
                    tr
                      th.font-weight-bold Nombre usuario
                      th 
                      th
                      th.text-center.font-weight-bold(width="12%")
                        | Planificación <br> semanal
                      th.text-center.font-weight-bold(width="12%")
                        | Diálogos <br> de desempeño
                      th.text-center.font-weight-bold(width="12%")
                        | Seguimiento <br> diario A
                      th.text-center.font-weight-bold(width="12%")
                        | Seguimiento <br> diario B
                      th.text-center.font-weight-bold(width="12%")
                        | Confirmación <br> de procesos
                  tbody
                    tr(v-for="(collab,n) in weeklyEvaluations")
                      td
                        div
                          | {{ collab.name }}
                      td
                        div
                          | 
                      td
                        div.justify-content-center
                          router-link(:to="{name: 'Resumen pautas externo', params: { id: collab.id } }", :id="'view-' + n")
                            i.icono.icono-ver.ad_text-primary.align-top
                          b-tooltip(:target="'view-' + n")
                            | Pauta anual de 
                            strong &nbsp;{{collab.name}}
                      td
                        div.justify-content-center(v-if="collab.PS == 'Todo'")
                          a(@click="evaluateEval({name: 'Ver pauta externo', params: { id: collab.id, type: 'PS'} })")
                            | Ejecutar
                            i.icon-file-plus.align-top.font-weight-bold.ml-2
                        div.justify-content-center(v-else-if="collab.PS == 'N/A'")
                          | N/A
                        div.justify-content-center(v-else-if="collab.PS == 'autonomous'")
                          | Autónomo
                        div.justify-content-center(v-else-if="collab.PS == 'avance'")
                          a(@click="seeDetailEval({name: 'Ver avance externo', params: { id: collab.id_eval, collab: collab.id, type: 'PS'} })")
                            | Completar
                            i.icon-file-plus.align-top.font-weight-bold.ml-2
                        div.justify-content-center(v-else-if="isNaN(collab.PS)")
                          | {{collab.PS}}                        
                        div.justify-content-center(v-else)
                          a(@click="seeDetailEval({name: 'Historial pautas externo', params: { id: collab.id_eval, collab: collab.id, type: 'PS'} })")
                            | {{ collab.PS == "N/A" ? collab.PS : collab.PS.toFixed(2)+"%" }}
                      td
                        div.justify-content-center(v-if="collab.DDD == 'Todo'")
                          a(@click="evaluateEval({name: 'Ver pauta externo', params: { id: collab.id, type: 'DDD'} })")
                            | Ejecutar
                            i.icon-file-plus.align-top.font-weight-bold.ml-2
                        div.justify-content-center(v-else-if="collab.DDD == 'N/A'")
                          | N/A
                        div.justify-content-center(v-else-if="collab.DDD == 'autonomous'")
                          | Autónomo
                        div.justify-content-center(v-else-if="collab.DDD == 'avance'")
                          a(@click="seeDetailEval({name: 'Ver avance externo', params: { id: collab.id_eval, collab: collab.id, type: 'DDD'} })")
                            | Completar
                            i.icon-file-plus.align-top.font-weight-bold.ml-2
                        div.justify-content-center(v-else-if="isNaN(collab.DDD)")
                          | {{collab.DDD}}
                        div.justify-content-center(v-else)
                          a(@click="seeDetailEval({name: 'Historial pautas externo', params: { id: collab.id_eval, collab: collab.id, type: 'DDD'} })")
                            | {{ collab.DDD == "N/A" ? collab.DDD : collab.DDD.toFixed(2)+"%" }}
                      td
                        div.justify-content-center(v-if="collab.SDA == 'Todo'")
                          a(@click="evaluateEval({name: 'Ver pauta externo', params: { id: collab.id, type: 'SDA'} })")
                            | Ejecutar
                            i.icon-file-plus.align-top.font-weight-bold.ml-2
                        div.justify-content-center(v-else-if="collab.SDA == 'N/A'")
                          | N/A
                        div.justify-content-center(v-else-if="collab.SDA == 'autonomous'")
                          | Autónomo
                        div.justify-content-center(v-else-if="collab.SDA == 'avance'")
                          a(@click="seeDetailEval({name: 'Ver avance externo', params: { id: collab.id_eval, collab: collab.id, type: 'SDA'} })")
                            | Completar
                            i.icon-file-plus.align-top.font-weight-bold.ml-2
                        div.justify-content-center(v-else-if="isNaN(collab.SDA)")
                          | {{collab.SDA}}
                        div.justify-content-center(v-else)
                          a(@click="seeDetailEval({name: 'Historial pautas externo', params: { id: collab.id_eval, collab: collab.id, type: 'SDA'} })")
                            | {{ collab.SDA == "N/A" ? collab.SDA : collab.SDA.toFixed(2)+"%" }}
                      td
                        div.justify-content-center(v-if="collab.SDB == 'Todo'")
                          a(@click="evaluateEval({name: 'Ver pauta externo', params: { id: collab.id, type: 'SDB'} })")
                            | Ejecutar
                            i.icon-file-plus.align-top.font-weight-bold.ml-2
                        div.justify-content-center(v-else-if="collab.SDB == 'N/A'")
                          | N/A
                        div.justify-content-center(v-else-if="collab.SDB == 'autonomous'")
                          | Autónomo
                        div.justify-content-center(v-else-if="collab.SDB == 'avance'")
                          a(@click="seeDetailEval({name: 'Ver avance externo', params: { id: collab.id_eval, collab: collab.id, type: 'SDB'} })")
                            | Completar
                            i.icon-file-plus.align-top.font-weight-bold.ml-2
                        div.justify-content-center(v-else-if="isNaN(collab.SDB)")
                          | {{collab.SDB}}
                        div.justify-content-center(v-else)
                          a(@click="seeDetailEval({name: 'Historial pautas externo', params: { id: collab.id_eval, collab: collab.id, type: 'SDB'} })")
                            | {{ collab.SDB == "N/A" ? collab.SDB : collab.SDB.toFixed(2)+"%" }}
                      td
                        div.justify-content-center(v-if="collab.CP == 'Todo'")
                          a(@click="evaluateEval({name: 'Ver pauta externo', params: { id: collab.id, type: 'CP'} })")
                            | Ejecutar
                            i.icon-file-plus.align-top.font-weight-bold.ml-2
                        div.justify-content-center(v-else-if="collab.CP == 'N/A'")
                          | N/A
                        div.justify-content-center(v-else-if="collab.CP == 'autonomous'")
                          | Autónomo
                        div.justify-content-center(v-else-if="collab.CP == 'avance'")
                          a(@click="seeDetailEval({name: 'Ver avance externo', params: { id: collab.id_eval, collab: collab.id, type: 'CP'} })")
                            | Completar
                            i.icon-file-plus.align-top.font-weight-bold.ml-2
                        div.justify-content-center(v-else-if="isNaN(collab.CP)")
                          | {{collab.CP}}
                        div.justify-content-center(v-else)
                          a(@click="seeDetailEval({name: 'Historial pautas externo', params: { id: collab.id_eval, collab: collab.id, type: 'CP'} })")
                            | {{ collab.CP == "N/A" ? collab.CP : collab.CP.toFixed(2)+"%" }}

    b-modal(:id='infoModal.id', centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
      <template v-slot:modal-title>
        h3.font-weight-bold.mb-0 {{infoModal.title}}
      </template>
      p.text-center {{ infoModal.content }}
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        .col-12.d-flex.justify-content-around
            b-button.px-4(size="lg", variant="danger", @click="askImpediment()")
              | No
            b-button.px-4(size="lg", variant="outline-secondary", @click="markAsAutonomous()")
              | Autónomo
            b-button.px-4(size="lg", variant="success", @click="gotToEvaluate()")
              | Si
      </template>

    b-modal(:id='impedimentModal.id', centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
      <template v-slot:modal-title>
        h3.font-weight-bold.mb-0 {{impedimentModal.title}}
      </template>
        .col.px-0.ad_select
          select(v-model="selectedTypeImp", @change='getProducts($event)')
            option(:value="null" disabled) Seleccione impedimento
            option(:value="typeimpediment" v-for="typeimpediment in typeimpediments" :key="typeimpediment._id") {{typeimpediment.name}}
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        .col-12.d-flex.justify-content-around
            b-button.px-4(size="lg", variant="danger", @click="markImpediment()")
              | Terminar
      </template>          
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex';

export default {
  name: 'ConsultorOCExt',

  data () {
    return {
      user: {},
      weeklyEvaluations: [],
      collabsInformation: [],
      totalPlans: 0,
      guidelines: [],
      answers: [],
      infoModal: {
        id: 'check-before-eval',
        title: '¡Atención!',
        content: '¿Pudiste realizar la evaluacion?'
      },
      impedimentModal: {
        id: 'impediments-eval',
        title: '¡Elige motivo!'
      },
      dataRoute: {},
      typeimpediments: [],
      selectedTypeImp: null
    }
  },
  methods: {
    moment,
    ...mapActions('consultant', [
      'actualWeekEvaluations', 'getEvaluationQuestions', 'answerGuideline'
    ]),
    ...mapActions('user', [
      'collabsWeekInformation',
    ]),
    ...mapActions('typeimpediment', [
      'typeImpedimentList'
    ]),
    getCollabsWeekInformation() {
      const vm = this;
      const loading = vm.$toast.loading('Cargando colaboradores...')
      vm.collabsWeekInformation(vm.user.id).then(response => {
        vm.collabsInformation = vm.$store.getters['user/getMyCollabsInformation']
        vm.totalPlans = response
      })
      loading.hide()
    },
    seeDetailEval(data) {
      const vm = this
      vm.$router.push(data)
    },
    gotToEvaluate() {
      const vm = this
      vm.$router.push(vm.dataRoute)
    },
    evaluateEval(data) {
      const vm = this
      vm.dataRoute = data
      vm.$bvModal.show(vm.infoModal.id)
    },
    askImpediment() {
      const vm = this
      vm.$bvModal.hide(vm.infoModal.id)
      const loading = vm.$toast.loading('Obteniendo impedimentos...')
      vm.typeImpedimentList().then(() => {
        vm.typeimpediments = vm.$store.getters['typeimpediment/getTypeImpedimets']
        loading.hide()
        vm.$bvModal.show(vm.impedimentModal.id)
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    markImpediment() {
      const vm = this
      const loading = vm.$toast.loading('Enviando...')
      vm.getEvaluationQuestions(vm.dataRoute.params.type).then(() => {
        vm.guidelines = vm.$store.getters['consultant/getGuidelines']
        vm._toZeroScore().then(() => {
          vm.answerGuidelines(vm.dataRoute.params.type, false, vm.selectedTypeImp, 2).then(() => {
            for (let index in vm.weeklyEvaluations) {
              if (vm.weeklyEvaluations[index].id == vm.dataRoute.params.id) {
                vm.weeklyEvaluations[index][vm.dataRoute.params.type] = vm.selectedTypeImp.name
              }
            }
            vm.$bvModal.hide(vm.impedimentModal.id)
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Pauta de evaluacion guardada con impedimento',
              closeable: true,
              duration: 5000
            })
          }, (err) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: err,
              closeable: true,
              duration: 5000
            })
          })
        }, (e) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: e,
            closeable: true,
            duration: 5000
          })  
        })      
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    evaluateWithZero() {
      const vm = this
      const loading = vm.$toast.loading('Enviando evaluación...')
      vm.getEvaluationQuestions(vm.dataRoute.params.type).then(() => {
        vm.guidelines = vm.$store.getters['consultant/getGuidelines']
        vm._toZeroScore().then(() => {
          vm.answerGuidelines(vm.dataRoute.params.type, false, null, 2).then(() => {
            for (let index in vm.weeklyEvaluations) {
              if (vm.weeklyEvaluations[index].id == vm.dataRoute.params.id) {
                vm.weeklyEvaluations[index][vm.dataRoute.params.type] = 0
              }
            }
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Pauta de evaluacion guardada con 0',
              closeable: true,
              duration: 5000
            })
          }, (err) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: err,
              closeable: true,
              duration: 5000
            })
          })
        }, (e) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: e,
            closeable: true,
            duration: 5000
          })  
        })      
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    _toZeroScore() {
      return new Promise((resolve, reject) => {
        try {
          const vm = this
          for (let index in vm.guidelines) {
            vm.answers.push({_id: vm.guidelines[index]._id, score: '0'})
          }
          resolve()  
        } catch (e) {
          reject(e)
        }
      })
    },
    answerGuidelines(type, autonomous, typeimpediment, order) {
      return new Promise((resolve, reject) => {
        const vm = this;
        const week_number = moment().format("W")      
        const data = {
          consultant_user: vm.$store.state.auth.user.id,
          user_evaluated: vm.dataRoute.params.id,
          collab_involve: null,
          body: {
            questions: vm.answers,
            week_number: week_number,
            type: type,
            autonomous: autonomous,
            typeimpediment: typeimpediment,
            order: order
          }
        }      
        vm.answerGuideline(data).then(response => {
          if (response) {
            resolve()
          } else {
            console.log(response)
            reject('Ha habido un error')
          }
        })        
      })        
    },
    markAsAutonomous() {
      const vm = this
      const loading = vm.$toast.loading('Enviando evaluación...')
      vm.getEvaluationQuestions(vm.dataRoute.params.type).then(() => {
        vm.guidelines = vm.$store.getters['consultant/getGuidelines']
        vm._toZeroScore().then(() => {
          vm.answerGuidelines(vm.dataRoute.params.type, true, null, 2).then(() => {
            for (let index in vm.weeklyEvaluations) {
              if (vm.weeklyEvaluations[index].id == vm.dataRoute.params.id) {
                vm.weeklyEvaluations[index][vm.dataRoute.params.type] = 'autonomous'
              }
            }
            vm.$bvModal.hide(vm.infoModal.id)
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Pauta de evaluacion marcada como autonomo',
              closeable: true,
              duration: 5000
            })
          }, (err) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: err,
              closeable: true,
              duration: 5000
            })
          })
        }, (e) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: e,
            closeable: true,
            duration: 5000
          })  
        })      
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }
  },
  mounted() {
    const vm = this;
    const { id } = vm.$store.state.auth.user
    const loading = vm.$toast.loading('Cargando evaluaciones semanales...')
    vm.user = vm.$store.getters['auth/getUserInfo']
    if (vm.user.profile.name == 'Consultor externo') {
      vm.actualWeekEvaluations(id).then(() => {
        vm.weeklyEvaluations = vm.$store.getters['consultant/getWeeklyEvaluations']
      })
      loading.hide()
      vm.getCollabsWeekInformation()
    } else {
      loading.hide()      
      vm.$router.replace({ path: '/permission' })
    }
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/views/consultor-externo/consultor-externo-observaciones-calidad.vue